import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import kazTranslates from "./kaz.json";
import rusTranslates from "./rus.json";

i18n.use(initReactI18next).init({
  resources: {
    ru: {
      translation: rusTranslates,
    },
    kk: {
      translation: kazTranslates,
    },
  },
  lng: "kk",
  fallbackLng: "ru",
  interpolation: {
    escapeValue: false,
  },
  compatibilityJSON: "v3",
});

export default i18n;
